export default "__VITE_ASSET__CvvEYd7Z__"